module.exports = __webpack_public_path__ + "static/media/halong-bay-before.9ed8b464.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/digitalNomad/photo-editing/halong-bay-before.jpg
// module id = 378
// module chunks = 0